import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { AuftragPosition, deleteAuftragPosition } from 'api/auftragPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface AuftragPositionDeleteProps {
    auftragPosition: AuftragPosition;
    onClose: (refetch: boolean) => void;
}

export const AuftragPositionDelete: React.FC<AuftragPositionDeleteProps> = ({ auftragPosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (auftragPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteAuftragPosition(auftragPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Auftragsposition löschen',
                subText: 'Auftragsposition "' + auftragPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
